import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

// Actions
import { Logout } from '@app/store/auth/auth.actions';

// Environment
import { environment } from '@env';

// Models
import { UIStateModel } from '@app/models/ui.model';

// Store
import { AuthenticationStateModel, AuthState } from '@app/store/auth/auth.state';
import { UIState } from '@app/store/app/states/ui/ui.state';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EnvironmentNames } from 'src/environments/environment.type';

@Component({
  standalone: true,
  selector: 'app-header',
  imports: [CommonModule, RouterLink, MatToolbar, MatIcon, MatMenuModule, MatButtonModule, AsyncPipe, MatTooltipModule],
  templateUrl: './header.block.html',
  styleUrl: './header.block.scss',
})
export class HeaderBlock implements OnInit {
  user$!: Observable<AuthenticationStateModel>;
  app: UIStateModel['app'] | undefined;

  get appEnv() {
    return environment.envName;
  }

  get appName() {
    return environment.name;
  }

  get showEnvironment() {
    return environment.showEnv ?? false;
  }

  get compileMode() {
    return environment.isProduction ? 'production' : 'development';
  }

  constructor(private store: Store) {
    this.user$ = this.store.select(AuthState.getAuthData);
  }

  ngOnInit() {
    this.app = this.store.selectSnapshot(UIState.getAppDetails);
  }

  public logoutUser() {
    this.store.dispatch(new Logout());
  }

  public getBuildTooltipText(): string {
    if (environment.envName === EnvironmentNames.Production) {
      return `
        ${environment.build.tag}
        ${environment.build.buildNumber}
      `;
    }

    return `
      ${environment.build.branchName}
      ${environment.build.buildNumber}
    `;
  }

  public getMailToLink(): string {
    return `mailto:${environment.support.mail.to}?subject=Raven - Bug / Enhancement Request&body=${this.getBuildTooltipText()}&cc=${environment.support.mail.cc ?? ''}`;
  }
}
